export default __webpack_public_path__ + "static/media/MarketRealCase1-en-moblie.ab777c5e.jpg";